export const ADD_EXPENSE = 'ADD_EXPENSE';
export const DELETE_EXPENSE = 'DELETE_EXPENSE';
export const SEARCH_EXPENSE = 'SEARCH_EXPENSE'